import React from "react";

const StagesList = ({ stage, data, handleQuestions }) => {
  return (
    <div className="flex flex-col border border-r-slate-200 border-t-0 border-b-0 border-l-0 overflow-y-auto max-h-[380px] scrollbarBlack">
      {stage !== null && stage.length > 0
        ? stage.map((response, index) => {
            const { complete, schedule } = response;
            let className = complete
              ? "#01C851"
              : schedule !== ""
                ? "#33B5E7"
                : "#5C5C5C";

            return (
              <div className="flex items-center" key={index}>
                <div className="px-4">
                  <div
                    className={`border rounded-full w-[20px] h-[20px]`}
                    style={{ backgroundColor: className }}
                  ></div>
                </div>
                <div
                  className="shadow shadow-black rounded-lg my-2 w-[300px] h-auto cursor-pointer"
                  onClick={() => handleQuestions(response.idReponseStage)}
                >
                  <div className="px-2">
                    <span className="text-xs font-[Gravity]">
                      {response.schedule}
                    </span>
                  </div>
                  <div className="px-2 grid grid-cols-2">
                    <span className="text-md font-[Gravity] font-bold">
                      #{data.detailTrip[0].delivery}
                    </span>
                    <span className="text-md font-[Gravity] font-bold">
                      {response.name}
                    </span>
                  </div>
                  <div className="px-4">
                    <span className="text-xs font-[Gravity]">
                      {data.detailTrip[0].origin.shPt}-
                      {data.detailTrip[0].destination.shPt}
                    </span>
                  </div>
                </div>
              </div>
            );
          })
        : null}
    </div>
  );
};

export default StagesList;
